module.exports = __webpack_public_path__ + "media/app/fonts/catamaran-v4-latin-regular-c77e544e407837a5515eb4aca1bb2f49.ttf";